import { defaultInstance } from "./instances";

// ! any
export const request: () => Promise<any> = async () =>
  await defaultInstance.get(`/captcha/request`);
